module.exports = __webpack_public_path__ + "abc225e2952bda0275b426b6cf66ba44.jpg";